export const FOOTER_FESTIVAL_NAME = '2025 목포해상W쇼';
export const FOOTER_ADDRESS =
  '(58631) 전라남도 목포시 양을로 203 (용당동) 목포시청';
export const FOOTER_PHONE_NUMBER =
  '대표전화 061-272-2171 / 대표팩스 061-270-3598';
export const FOOTER_COPYRIGHT = 'Copyright ⓒ MOKPO-CITY. ALL RIGHTS RESERVED.';
